"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveTP = void 0;
const types_1 = require("./types");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const utils_1 = require("../utils");
const utils_2 = require("../../utils");
/**
 * 运行中仓位的止盈限制
 */
class ActiveTP extends types_1.TPSLLimiter {
    valueOf() {
        var _a, _b;
        const { order, curPrice, takerFee, mode, tpslParams } = this.params;
        const isLong = order.side === interface_1.CustomOrderSide.BUY;
        // 收益最大/最小化的价格限制
        const priceModeRes = {
            min: new trade_utils_lib_1.SafeDecimal(curPrice),
            // 做多：持仓均价*1000
            // 做空：0
            max: isLong ? new trade_utils_lib_1.SafeDecimal(order.active_position_avg_price).mul(1000) : new trade_utils_lib_1.SafeDecimal(0),
        };
        switch (mode) {
            case interface_1.SimpleFutures.TPSLMode.simple_trailing:
                const profit = utils_2.SimpleFuturesUtils.getTotalProfit(order, curPrice);
                const profitRate = new trade_utils_lib_1.SafeDecimal(profit).div(new trade_utils_lib_1.SafeDecimal(order.quote_invest));
                if (order.is_triggered_trailing) {
                    // 已触发的追踪出场
                    // 修改追踪设置时，用户可输入的最小回撤比例需> max(0,历史最高收益率 - 当前总利润率) && <(1 + 历史最高收益率)
                    return {
                        min: trade_utils_lib_1.SafeDecimal.max(0, new trade_utils_lib_1.SafeDecimal(order.hl_reach_ratio).sub(profitRate)),
                        max: new trade_utils_lib_1.SafeDecimal(order.hl_reach_ratio).add(1),
                    };
                }
                // 未触发
                // >=当前收益率+0.1%*杠杆倍数
                return {
                    min: new trade_utils_lib_1.SafeDecimal(0),
                    max: new trade_utils_lib_1.SafeDecimal((_b = (_a = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit) === null || _a === void 0 ? void 0 : _a.trailing) === null || _b === void 0 ? void 0 : _b.trigger_rate).add(1),
                };
            case interface_1.SimpleFutures.TPSLMode.simple_amount:
                return {
                    min: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfit(priceModeRes.min, { order, takerFee }),
                    max: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfit(priceModeRes.max, { order, takerFee }),
                };
            case interface_1.SimpleFutures.TPSLMode.simple_price:
                return isLong ? priceModeRes : { min: priceModeRes.max, max: priceModeRes.min };
            case interface_1.SimpleFutures.TPSLMode.simple_rate:
            default:
                return {
                    min: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfitRate(priceModeRes.min, { order, takerFee }),
                    max: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfitRate(priceModeRes.max, { order, takerFee }),
                };
        }
    }
}
exports.ActiveTP = ActiveTP;
